export const DATETIMEPICKER_DATA_KEY = 'xdsoft_datetimepicker';

// NOTE: This module initializes xdsoft datetimepicker on inputs with
// `.datepicker` or `.datetimepicker` class names. The `.datepicker`
// CSS class was intentionally kept for backwards compatibility with
// existing ERB templates. jQuery UI datepicker is no longer loaded
// in the bundle; its widget method is disabled in ui.js so that
// only the xdsoft datetimepicker runs.
export function initDatepickers($, $scope = $(document)) {
    $scope = $($scope);
    if (!$.fn.datetimepicker) {
        // NOTE: typeof process is used instead of import.meta.env.MODE
        // because it is portable across Vite builds (static replacement),
        // plain browser loads (process is undefined), and Node.js test environments.
        if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production') {
            console.warn('jquery-datetimepicker plugin not found; datepickers will not initialize');
        }
        return;
    }

    const $dateTimeInputs = $scope.find(".datetimepicker");
    const $dateInputs = $scope.find(".datepicker");

    $dateTimeInputs.each(function(){
        const $field = $(this);
        // Idempotency key: DATETIMEPICKER_DATA_KEY is internal to the xdsoft
        // plugin. If the plugin is ever replaced, update the constant value.
        if ($field.data(DATETIMEPICKER_DATA_KEY)) return;

        $field.datetimepicker({
            format: "Y-m-d H:i",
            minDate: $field.data("min-date"),
        });
    });

    $dateInputs.each(function(){
        const $field = $(this);
        // Idempotency key: DATETIMEPICKER_DATA_KEY is internal to the xdsoft
        // plugin. If the plugin is ever replaced, update the constant value.
        if ($field.data(DATETIMEPICKER_DATA_KEY)) return;

        $field.datetimepicker({
            format: "Y-m-d",
            minDate: $field.data("min-date"),
            timepicker: false,
        });
    });
}
